import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export type SwitchSelectItem<T> = {
  value: T;
  render: () => ReactNode;
};

type Props<T> = {
  items: SwitchSelectItem<T>[];
  value: T;
  onValueChange: (_newValue: T) => void;
};

export const SwitchSelectButton = <T extends boolean>({ items, value, onValueChange }: Props<T>) => {
  return (
    <div className="flex items-center">
      {items.map((item, index) => (
        <button
          type="button"
          key={index}
          className={twMerge(
            'text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 font-medium text-sm px-5 py-2.5 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600',
            index === 0 && 'rounded-l-lg',
            index === items.length - 1 && 'rounded-r-lg',
            value === item.value &&
              'text-white bg-blue-700 hover:bg-blue-800 border-blue-700 hover:border-blue-800 font-medium text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 dark:border-blue-600 dark:hover:border-blue-700 focus:outline-none',
          )}
          onClick={() => onValueChange(item.value)}
        >
          {item.render()}
        </button>
      ))}
    </div>
  );
};
